/* eslint-disable react/jsx-props-no-spreading */
import useAuth from '@/hooks/useAuth'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import FormMistreatmentType from '../Form'

function Row({ mistreatmentType, onUpdated }) {
  const { licensing } = useAuth()

  const hasOsm = licensing?.hasOsmCredentials

  return (
    <tr>
      <td>{mistreatmentType.title}</td>
      <td>{mistreatmentType.description}</td>
      <td className="text-center">
        {mistreatmentType.active ? (
          <span className="label label-success">Ativo</span>
        ) : (
          <span className="label label-error">Inativo</span>
        )}
      </td>
      <td className="text-right">
        <div className="d-flex" style={{ justifyContent: 'flex-end' }}>
          {
            hasOsm && (
              <Link
                to={`/app/mistreatment-types/${mistreatmentType.id}/osm-integration`}
                className="btn btn-action btn-sm mr-1 tooltip tooltip-left"
                data-tooltip="Integração com OS-m"
              >
                <i className="fas fa-cogs" />
              </Link>
            )
          }
          <FormMistreatmentType
            mistreatmentType={mistreatmentType}
            onSuccess={onUpdated}
            ButtonComponent={(props) => (
              <a {...props} data-tooltip="Editar" className="btn btn-action btn-primary btn-sm tooltip tooltip-left">
                <i className="fas fa-edit" />
              </a>
            )}
          />
        </div>
      </td>
    </tr>
  )
}

Row.propTypes = {
  mistreatmentType: PropTypes.objectOf(Object).isRequired,
  onUpdated: PropTypes.func.isRequired,
}

export default Row
